module.exports = __webpack_public_path__ + "resources/rank_num_7.e4c94bdb43d417ff.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/label/img/rank_num_7.png
// module id = 546
// module chunks = 0 1 2 3